// A conta da troca de plano que a TELA mostra — uma fonte só pros dois
// visuais da /checkout/trocar (padrão e Reservei, 2026-10-20). Quem cobra de
// verdade é o servidor; isto só explica o valor antes do clique, e duas cópias
// divergiriam justamente no número que o cliente confere.

import type { EligibleUpgrade, PlanChangePreview } from './plan-change-api';

export interface PlanChangeMath {
  /** Fatura de renovação aberta: trocar SUBSTITUI a fatura (sem pro-rata nem agendamento). */
  isRenewal: boolean;
  /** Plano menor fora da renovação: nada agora, vale no fim do ciclo já pago. */
  isDowngrade: boolean;
  /** Renovação: valor da fatura nova (mensalidade com o desconto vigente). */
  renewalAmount: string;
  renewalHasDiscount: boolean;
  /** O que sai do bolso agora. */
  amountNow: number;
  /** Zero a pagar (trial ou vencimento hoje): não pede forma de pagamento. */
  isFree: boolean;
  needsPayment: boolean;
  daysLeft: number;
}

export function planChangeMath(preview: PlanChangePreview, selected: EligibleUpgrade | null): PlanChangeMath {
  const isRenewal = preview.mode === 'renewal';
  const isDowngrade = !isRenewal && selected?.direction === 'downgrade';
  const renewalAmount = selected?.effective_renewal_price ?? selected?.renewal_price ?? '0';
  const renewalHasDiscount =
    Boolean(selected?.renewal_price) &&
    Boolean(selected?.effective_renewal_price) &&
    selected?.renewal_price !== selected?.effective_renewal_price;
  const amountNow = Number(isRenewal ? renewalAmount : (selected?.proration_amount ?? '0'));
  const isFree = !isRenewal && !isDowngrade && amountNow <= 0;
  const needsPayment = Boolean(selected) && (isRenewal || (!isDowngrade && !isFree));
  return {
    isRenewal,
    isDowngrade,
    renewalAmount,
    renewalHasDiscount,
    amountNow,
    isFree,
    needsPayment,
    daysLeft: selected?.days_remaining ?? 0,
  };
}
